export default "__VITE_ASSET__B6vr2HV8__"